import { render, staticRenderFns } from "./check-status.vue?vue&type=template&id=19595284&scoped=true&"
import script from "./check-status.vue?vue&type=script&lang=js&"
export * from "./check-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19595284",
  null
  
)

export default component.exports